import Alpine from 'alpinejs'
import globalStore from '@/js/store'
import components from '@/js/alpine'

import '@/styles/main.scss'

if (!window.acf) {
  window.Alpine = Alpine

  Alpine.store('global', globalStore())

  const registerComponent = async (component) => {
    let componentSlug = component.replace(/-./g, (x) => x[1].toUpperCase())

    if (document.querySelectorAll(`[x-data^=${componentSlug}]`).length > 0) {
      new URL(`./alpine/${component}.js`, import.meta.url)

      await import(`./alpine/${component}.js`)
        .then((module) => {
          Alpine.data(componentSlug, module.default)
        })
        .catch((error) => {
          console.error(error)
        })
    }
  }

  const registerComponents = async () => {
    for (const component of components) {
      await registerComponent(component)
    }
    Alpine.start()
  }

  ;(async () => {
    await registerComponents()
  })()
}

// load defered videos
window.videosReady = false

document.onreadystatechange = function (event) {
  if (document.readyState === 'complete') {
    const videos = document.querySelectorAll('[data-src-defer]')
    const videos_array = [...videos]
    videos_array.forEach((video) => {
      video.setAttribute('src', video.getAttribute('data-src-defer'))
    })
    window.videosReady = true
  }
}

// Alert bar functionality
const formData = new FormData();

formData.append('action', 'get_alert_bar');
formData.append('post_id', wp_config.post_id);

// fetch alert bar
fetch(wp_config.ajaxurl, {
  method: 'POST',
  body: formData,
  cache: 'no-cache',
  headers: {
    page_cache_maximum_age: 0,
  },
})
.then((response) => response.json())
.then((data) => {
  if (data.enabled) {
    document.getElementById('alertBar').classList.add('is-active')
    document.getElementById('alertBar').innerHTML = `
        <section class="alert-bar alert-bar--${data.background_color}">
            <div class="alert-bar__inner">
                <div class="alert-bar__text">${data.message}</div>
            </div>
        </section>
    `
  }
})

class FormAssemblyForms {
  constructor() {
    this.forms = document.querySelectorAll('form[action*="lvc.tfaforms.net"]');

    if (this.forms.length > 0) {
      this.listen();
    }
  }

  listen() {
    this.forms.forEach((form) => {
        form.addEventListener('form.validation.formassembly', (e) => {
            if ("passed" === e.detail.statusText) {
                dataLayer.push({
                    event: "formassembly_submit",
                    form_id: form.id
                });
            } else {
            }
        })
    });
  }
} 

const formAssemblyForms = new FormAssemblyForms();

// Autofill master degree field in FormAssembly
// Check if particular form is on page
if (document.getElementById('217885')) {
  const params = new URLSearchParams(window.location.search);
  const degree = params.get('degree');
  const poi = params.get('poi');

  // Only proceed if both degree and poi are present
  if (degree && poi) {
    // Helper to wait for the field to appear
    function waitForField(selector, timeout = 5000) {
      return new Promise((resolve, reject) => {
        const interval = 100;
        let elapsed = 0;
        const check = () => {
          const el = document.querySelector(selector);
          if (el) return resolve(el);
          elapsed += interval;
          if (elapsed >= timeout) return reject();
          setTimeout(check, interval);
        };
        check();
      });
    }

    // Set the degree field
    waitForField('#tfa_597, [title="Degree"]').then((degreeField) => {
      if (degree.toLowerCase() === 'master') {
        const masterOption = Array.from(degreeField.options).find(
          (option) => option.text.trim().toLowerCase() === 'master'
        );
        if (masterOption) {
          degreeField.value = masterOption.value;
        }
      }
    }).catch(() => {
      console.warn('Degree field not found');
    });

    // Find and set Program of Interest field
    waitForField('#tfa_626, [title="Academic Program of Interest"]').then((field) => {
      field.value = poi;
      field.focus();
    }).catch(() => {
      console.warn('Academic Program of Interest field not found');
    });
  }
}

// ChatbotWidget class for embedding a chatbot widget on the site
// Handles rendering, toggling, and communication with the embedded iframe
class ChatbotWidget {
    /**
     * Constructor for ChatbotWidget
     * @param {Object} options - Configuration options
     * @param {string} options.embedUrl - URL for the chatbot iframe
     * @param {string} options.iconUrl - URL for the chatbot icon
     */
    constructor(options = {
        embedUrl: '',
        iconUrl: ''
    }) {
        this.options = options;
        this.active = false;
        this.element = null;
        this.embed = null;

        this.render();
        this.listen();
    }

    /**
     * Renders the chatbot widget in the DOM
     */
    render() {
        const chatbotWidgetContainer = document.createElement('div');
        chatbotWidgetContainer.id = 'chatbot-widget';

        const chatbotWidgetHeader = document.createElement('div');
        chatbotWidgetHeader.className = 'chatbot-widget__header';

        const headerLogo = document.createElement('div');
        headerLogo.className = 'chatbot-widget__header-logo';
        headerLogo.innerHTML = '<img src="' + this.options.iconUrl + '" alt="Chat icon">';

        const headerTitle = document.createElement('div');
        headerTitle.className = 'chatbot-widget__header-title';
        headerTitle.textContent = 'Let’s Chat';

        const headerToggle = document.createElement('div');
        headerToggle.className = 'chatbot-widget__header-toggle';
        headerToggle.innerHTML = '<span class="line"></span><span class="line"></span>';

        const chatbotWidgetBody = document.createElement('div');
        chatbotWidgetBody.className = 'chatbot-widget__body';
        chatbotWidgetBody.innerHTML = '<iframe id="chatbotWidgetIframe" class="chatbot-widget__iframe" allow="local-network-access" src="' + this.options.embedUrl + '" frameborder="0"></iframe>';

        chatbotWidgetHeader.appendChild(headerLogo);
        chatbotWidgetHeader.appendChild(headerTitle);
        chatbotWidgetHeader.appendChild(headerToggle);

        chatbotWidgetContainer.appendChild(chatbotWidgetHeader);
        chatbotWidgetContainer.appendChild(chatbotWidgetBody);

        document.body.appendChild(chatbotWidgetContainer);

        this.element = chatbotWidgetContainer;
        this.embed = chatbotWidgetBody.querySelector('iframe');
    }

    /**
     * Sets up event listeners for the chatbot widget
     */
    listen() {
        this.element.addEventListener('click', () => {
            this.toggle();
        });

        if (this.embed) {
            window.addEventListener('message', this.handleMessage.bind(this));

            this.embed.addEventListener('load', this.handleLoad.bind(this));
            this.embed.addEventListener('error', this.handleError.bind(this));
        }
    }

    /**
     * Toggles the chatbot open/closed state
     */
    toggle() {
        if (this.active) {
            this.deactivate();
        } else {
            this.activate();
        }
    }

    /**
     * Activates (opens) the chatbot widget
     */
    activate() {
        this.active = true;

        document.documentElement.classList.add('chatbot-active');

        this.element.classList.add('is-active');
        this.element.classList.add('is-open');
    }

    /**
     * Deactivates (closes) the chatbot widget
     */
    deactivate() {
        this.active = false;

        document.documentElement.classList.remove('chatbot-active');

        this.element.classList.remove('is-active');
        this.element.classList.remove('is-open');
    }

    /**
     * Handles messages received from the chatbot iframe
     * @param {MessageEvent} event
     */
    handleMessage(event) {
        if (event.origin !== new URL(this.options.embedUrl).origin) {
            return;
        }

        const data = event.data;

        console.log('Received message from chatbot iframe:', data); 
    }

    /**
     * Handles iframe load event
     */
    handleLoad() {
        this.element.classList.add('is-loaded');
    }

    /**
     * Handles iframe error event
     */
    handleError() {
        console.error('Error loading chatbot iframe.');
        this.element.classList.add('is-error');
    }
}

function initChatbotWidget() {
  if (
    document.body.classList.contains('home') &&
    window.chatbotWidget === undefined
  ) {
    window.chatbotWidget = new ChatbotWidget({
      embedUrl: 'https://webapps.lvc.edu/lvc/',
      iconUrl: '/wp-content/uploads/2026/01/chatbot-logo.svg'
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initChatbotWidget);
} else {
  initChatbotWidget();
}